export const USER_ROLES_VIEWONLY = "view-only";
